<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    width="860px"
    :title="title"
    show-close
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :disabled="disabled"
      :shipmentCustomerCode="shipmentCustomerCode"
      :shipmentCustomerAddressCode="shipmentCustomerAddressCode"
      @reload="$emit('reload')"
      @close="close"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        v-if="!disabled"
        type="primary"
        size="small"
        @click="$refs.main.save()"
      >
        {{ this.$l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    shipmentCustomerCode: { type: String, default: '' },
    shipmentCustomerAddressCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
